export type AppAccountState = 'disabled' | 'timestamp' | 'registered' | 'unregistered';

// Precedence: Clerk facts win over Firebase. Timestamp is reserved for Clerk logins.
export function getAppAccountState(member: {
  disabled?: boolean | null;
  hasLoggedIn?: boolean | null;
  lastSignInAt?: number | null;
  hasAppAccount?: boolean | null;
  firebaseRegistered?: boolean | null;
}): AppAccountState {
  if (member?.disabled) return 'disabled';
  if (member?.hasLoggedIn && member?.lastSignInAt) return 'timestamp';
  if (member?.hasAppAccount) return 'registered';
  if (member?.firebaseRegistered) return 'registered';
  return 'unregistered';
}
